const e = [
  {
    prettyName: "Eternl",
    windowName: "eternl",
    iconName: "eternl",
    disabled: !1,
    externalInstallLink: "https://eternl.io/",
    alwaysShow: !0
  },
  {
    prettyName: "VESPR",
    windowName: "vespr",
    iconName: "vespr",
    disabled: !1,
    isMobileOnly: !0,
    externalInstallLink: "https://www.vespr.xyz/"
  },
  {
    prettyName: "Flint",
    windowName: "flint",
    iconName: "flint",
    disabled: !1,
    externalInstallLink: "https://flint-wallet.com/"
  },
  {
    prettyName: "Gero",
    windowName: "gerowallet",
    iconName: "gerowallet",
    disabled: !1,
    externalInstallLink: "https://gerowallet.io/"
  },
  {
    prettyName: "Begin",
    windowName: "begin",
    iconName: "begin",
    disabled: !1,
    externalInstallLink: "https://begin.is/"
  },
  {
    prettyName: "Lace",
    windowName: "lace",
    iconName: "lace",
    disabled: !0,
    externalInstallLink: "https://www.lace.io/",
    alwaysShow: !0
  },
  {
    prettyName: "Nami",
    windowName: "nami",
    iconName: "nami",
    disabled: !0,
    externalInstallLink: "https://namiwallet.io/",
    alwaysShow: !0
  },
  {
    prettyName: "Typhon",
    windowName: "typhoncip30",
    iconName: "typhon",
    disabled: !0,
    externalInstallLink: "https://typhonwallet.io/#/",
    alwaysShow: !0
  },
  {
    prettyName: "Nufi",
    windowName: "nufi",
    iconName: "nufi",
    disabled: !0,
    externalInstallLink: "https://nu.fi/"
  }
];
export {
  e as wallets
};
